define( [
	"./arr"
], function( arr ) {
	return arr.indexOf;
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/var/indexOf.js
 ** module id = 820
 ** module chunks = 2
 **/